import Templates from "./templates";
import $ from "jquery";
import helper from "./view-helper";
import {numFormat, formatDataVersion, addSaikoClass} from "../modules/util";
import {courseCalendarTemplateData} from "../modules/course-calendar";
import {LAYER_SPEED} from "../common-config";

export default {
	dataVersion: function(ev) {
		var version = ev.data.def.dataVersion[0];
		$("#forcia-data-version").html(formatDataVersion(version));
	},
	allCount: function(ev) {
		var count = ev.data.state.Count.dataCount;
		$("#forcia-all-count").html(numFormat(count));
	},
	pager: function(ev) {
		var store = ev.data;
		var count = store.state.Count.dataCount;
		var currentPage = store.params.page - 0 || 1;
		const itemPerPage = 10;
		const left = 1, width = 3;
		var nPage = Math.ceil(count / itemPerPage) || 1;
		var from = Math.max(Math.min(currentPage, nPage) - left, 1);
		var to = Math.min(from + width - 1, nPage);
		// to = currentPage のとき (つまり to = nPage のとき) width が不足するので再調整
		from = Math.max(to - width + 1, 1);
		var pagerInfo = {
			nPage: nPage,
			currentPage: currentPage,
			from: from,
			to: to,
			isFirstPage: currentPage === 1,
			isLastPage: currentPage === nPage,
			prevPageUrl: helper.getURL(store.params, "page", currentPage - 1, store.def.appBase),
			nextPageUrl: helper.getURL(store.params, "page", currentPage + 1, store.def.appBase)
		};
		var getPagerURL = function(page) {
			return helper.getURL(store.params, "page", page, store.def.appBase);
		};
		var pager = Templates.pager({pager: pagerInfo, getPagerURL: getPagerURL});
		$("#forcia-template-pager").html(pager);
	},
	deptLayer: function(ev) {
		var store = ev.data;
		var count = store.state.Count.depAirportCount;
		var noselect = { index: 0, name: "指定なし", code: "", order: "0"};
		var airports = [noselect].concat(store.def.depAirport);

		var list = _.map(airports, function(airport) {
			return Object.assign({
				count: numFormat(count[Number(airport.index)] || 0),
				isSelected: airport.code === store.params.depAirport,
				url: helper.getURL(store.params, "depAirport", airport.code, store.def.appBase)
			}, airport);
		});
		list.sort(function(a, b) { return Number(a.order) - Number(b.order); });
		const deptCondition = Templates.deptCondition({airports: list});
		$("#forcia-template-dept-condition").html(deptCondition);
	},
	destLayer: function(ev) {
		var store = ev.data;
		var regionCount = store.state.Count.regionCount;
		var countryCount = store.state.Count.countryCount;
		var noselect = { regionIndex: 0, region_name: "指定なし", region_code: "", region_order: "0"};
		var regions = [noselect].concat(store.def.region);
		var countries = store.def.country;
		var countryList = _.map(countries, function(country) {
			return Object.assign({
				count: numFormat(countryCount[Number(country.countryIndex) - 1] || 0),
				isSelected: country.country_code === store.params.dest0,
				url: helper.getURL(store.params, "dest0", country.country_code, store.def.appBase)
			}, country);
		});
		var countryGroup = _.groupBy(countryList, "regionIndex");

		var regionList = _.map(regions, function(region) {
			var isCountrySelected = _.find(countryGroup[region.regionIndex], { isSelected: true }) ? true : false;
			var sortedCountries = (countryGroup[region.regionIndex] || []).sort(function(a, b) {
				// 国の並びは件数の降順
				// C0 (中国のその他の都市) は最後尾にする
				return a.country_code === "C0" ? 1
					: b.country_code === "C0" ? -1
					: (countryCount[Number(b.countryIndex) - 1] || 0) - (countryCount[Number(a.countryIndex) - 1] || 0);
					// a.count は "12,345" のような文字列なのでソートに使えない
			});
			return Object.assign({
				count: numFormat(regionCount[Number(region.regionIndex)] || 0),
				isCountrySelected: isCountrySelected,
				isSelected: isCountrySelected || (region.region_code === store.params.dest0),
				url: helper.getURL(store.params, "dest0", region.region_code, store.def.appBase),
				countries: sortedCountries
			}, region);
		});
		regionList.sort(function(a, b) { return Number(a.region_order) - Number(b.region_order); });
		const destCondition = Templates.destCondition({regions: regionList});
		$("#forcia-template-dest-condition").html(destCondition);
	},
	openDeptLayer: function(ev) {
		if (ev.data.state.isOpenedDeptLayer) {
			$(".forcia-dept-layer").animate({left: 0}, LAYER_SPEED, () => {
				$(".forcia-dept-layer").css({position: "relative"});
				$("#wrapper").css({display: "none"});
				window.scrollTo(0, 0);
			});
		} else {
			$(".forcia-dept-layer").css({left: "120%", position: "fixed"});
			$("#wrapper").css({display: "block"});
		}
	},
	openDestLayer: function(ev) {
		if (ev.data.state.isOpenedDestLayer) {
			$(".forcia-dest-layer").animate({left: 0}, LAYER_SPEED, () => {
				$(".forcia-dest-layer").css({position: "relative"});
				$("#wrapper").css({display: "none"});
				window.scrollTo(0, 0);
			});
		} else {
			$(".forcia-dest-layer").css({left: "120%", position: "fixed"});
			$("#wrapper").css({display: "block"});
		}
	},
	openRegion: function(ev) {
		// FIX 要素の指定をもっとスマートにする
		var openedRegion = ev.data.state.openedRegion;
		var $h2s = $("h2.ipt_elmList_head");
		$h2s.each(function(index, h2) {
			var region = $(h2).data("region");
			var $span = $(h2).children("span");
			var $ul = $(h2).next("ul");
			if (region === openedRegion && $span.hasClass("close")) {
				$span.addClass("open").removeClass("close");
				$ul.css({display: "block"});
			} else {
				$span.addClass("close").removeClass("open");
				$ul.css({display: "none"});
			}
		});
	},
	courseCalendar: function(ev) {
		const isOpened = ev.data.state.courseCalendarLayer;
		if (isOpened) {
			const index = ev.data.state.courseListIndex;
			const course = ev.data.state.courseList[index];
			const courseCalendarFuncs = courseCalendarTemplateData({
				calendarHash: ev.data.def.calendarHash,
				minPrices: course.ary_minprice,
				maxPrices: course.ary_maxprice,
				stocks: course.ary_stock,
				startDateIndex: ev.data.def.startDate.index,
				saikoIndexes: course.ary_saikoIndex,
				withTourConductor: course.withTourConductor,
				dataVersion: ev.data.def.dataVersion[0]
			});
			const styleLeft = ev.data.state.monthIndex ? -ev.data.state.monthIndex * 100 : 0;
			const calendar = Templates.courseCalendar(Object.assign(
				courseCalendarFuncs, {
					months: ev.data.def.months,
					styleLeft: styleLeft,
					addSaikoClass: addSaikoClass
				}
			));
			window.__forcia__.scrollY = window.scrollY;

			$("#forcia-course-calendar").html(calendar);
			$("#forcia-course-calendar").animate({left: 0}, LAYER_SPEED, () => {
				$("#forcia-course-calendar").css({position: "relative"});
				$("#wrapper").css({display: "none"});
				window.scrollTo(0, 0);
			});
		} else {
			$("#forcia-course-calendar").css({left: "120%", position: "fixed"});
			$("#wrapper").css({display: "block"});
			window.scrollTo(0, window.__forcia__.scrollY);
		}
	}
};



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/landing/view.js